import { Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { detectDirectionWithSegmenter } from "src/utils";

const InfoBox = ({
  text,
  variant = "warning",
}: {
  text: string;
  variant?: "warning" | "error" | "info";
}) => {
  const direction = detectDirectionWithSegmenter(text);

  return (
    <Stack
      width={"100%"}
      bgcolor={
        variant === "error"
          ? "#FEE4E2"
          : variant === "info"
          ? "#F2F2FD"
          : "#FFF3EA"
      }
      borderRadius={"4px"}
      padding={1}
      direction={"row"}
      gap={"10px"}
    >
      <InfoOutlinedIcon
        color={
          variant === "error"
            ? "error"
            : variant === "info"
            ? "info"
            : "primary"
        }
      />
      <div dir={direction}>
        <Typography color={variant === "error" ? "error" : "black"}>
          {text}
        </Typography>
      </div>
    </Stack>
  );
};

export default InfoBox;
